<template>
    <v-row v-if="chartData">
        <v-col cols="12" md="6">
            <field-bar-chart :chartData="chartData"></field-bar-chart>
        </v-col>

        <v-col cols="12" md="6">
            <field-description :chartData="chartData"></field-description>
        </v-col>
    </v-row>
</template>

<script>
import FieldBarChart from './FieldBarChart'
import FieldDescription from './FieldDescription'

export default {
    components: {
        FieldBarChart,
        FieldDescription,
    },

    data: () => ({
        chartData: null,
    }),

    async created() {
        const result = await this.$api.get('deepening/summary')

        if (result.data.length !== 0) {
            this.chartData = result.data.map(e => ({
                ...e,
                percentage: Math.round(e.correct_answers / e.total_questions * 100)
            }))
        }
    }
}
</script>
